export const EventActionTypeEnum = {
  CREATE_EVENT_REQUEST: 'ADD_EVENT_REQUEST',
  CREATE_EVENT_SUCCESS: 'ADD_EVENT_SUCCESS',
  CREATE_EVENT_FAILURE: 'ADD_EVENT_FAILURE',
};

export const SignatureEventEnum = {
  EVENT_TYPE: 'signature_added',
  EVENT_DATA: '{}',
};



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Event/EventConstants.jsx